import CloseIcon, { DarkCLoseIcon } from "assets/Icons/icons/CloseIcon";
import { useIsDarkTheme } from "helpers/darktheme";

const CloseBtn = ({ onClose }) => {
    const isDarkTheme = useIsDarkTheme();

    return (
        <div className="py-4 px-6 border-b flex justify-end items-center">
            <button
                className="p-2 rounded-lg border border-[#D9D9D9] dark:border-[#424E59] dark:bg-[#424E59]"
                onClick={onClose}
            >
                {isDarkTheme ? <CloseIcon /> : <DarkCLoseIcon />}
            </button>
        </div>
    );
};

export default CloseBtn;
